import React from "react";
import DashboardCard from "src/components/shared/DashboardCard";
import {
  Timeline,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
  timelineOppositeContentClasses,
} from "@mui/lab";
import { Divider, Tooltip, Typography } from "@mui/material";
import TimelineSkeleton from "./TimelineSkeleton";
import moment from "moment";
import NoRecordsFound from "src/components/master/NoRecordsFound";

const StopsTimeline = ({ stopageData }) => {
  const isDataLoaded = Boolean(stopageData);

  const formatTimeDuration = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (hours > 0) {
      return `${hours} Hrs ${remainingMinutes} Min`;
    } else {
      return `${remainingMinutes} Min`;
    }
  };

  if (isDataLoaded) {
    if (stopageData.length) {
      return (
        <DashboardCard title="Trip Timeline">
          <Typography
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              fontFamily: "Sans-Serif",
              marginBottom: "10px",
            }}
            variant="h4"
          >
            Trip Timeline
          </Typography>
          <Divider />
          <Timeline
            className="theme-timeline"
            nonce={undefined}
            onResize={undefined}
            onResizeCapture={undefined}
            sx={{
              p: 0,
              mb: "-40px",
              [`& .${timelineOppositeContentClasses.root}`]: {
                flex: 0.5,
                paddingLeft: 0,
              },
            }}
            style={{
              paddingBottom: "60px",
            }}
          >
            {stopageData.map((item, index) => (
              <TimelineItem key={index}>
                <TimelineOppositeContent>
                  <Typography variant="h6" style={{ fontSize: "13px" }}>
                    <Tooltip
                      title={moment(item.startTime).format(
                        "DD-MM-YYYY h:mm:ss a"
                      )}
                    >
                      {moment(item.startTime).format("h:mm:ss a")}
                    </Tooltip>
                    -{"  "}
                    <Tooltip
                      title={moment(item.endTime).format(
                        "DD-MM-YYYY h:mm:ss a"
                      )}
                    >
                      {moment(item.endTime).format("h:mm:ss a")}
                    </Tooltip>
                  </Typography>
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot color="primary" variant="outlined" />
                  {index !== stopageData.length - 1 && <TimelineConnector />}
                </TimelineSeparator>
                <TimelineContent>
                  <Typography
                    variant="h6"
                    style={{ fontSize: "14px" }}
                  >{`${item.placeName}`}</Typography>

                  <Typography
                    variant="h6"
                    style={{ fontSize: "14px", color: "#6089FF" }}
                  >
                    {formatTimeDuration(parseFloat(item?.duration).toFixed(0))}
                  </Typography>
                </TimelineContent>
              </TimelineItem>
            ))}
          </Timeline>
        </DashboardCard>
      );
    } else {
      return (
        <DashboardCard title="">
          <Typography
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              fontFamily: "Sans-Serif",
              marginBottom: "10px",
            }}
            variant="h4"
          >
            Trip Timeline
          </Typography>
          <Divider />
          <NoRecordsFound />
        </DashboardCard>
      );
    }
  } else {
    return (
      <DashboardCard title="">
        <Typography
          style={{
            fontSize: "16px",
            fontWeight: "bold",
            fontFamily: "Sans-Serif",
            marginBottom: "10px",
          }}
          variant="h4"
        >
          Trip Timeline
        </Typography>
        <Divider />
        <TimelineSkeleton />
      </DashboardCard>
    );
  }
};

export default StopsTimeline;
